import {useState} from 'react';
import {InputNumber, Button, Row, Col} from 'antd';
import {TrashWidget} from "../widget/TrashWidget";

export const GramsEntryWidget = ({product, value, placeholder, min, max, precision, addonAfter, onChange, onDelete, props}) => {
    const [val, setVal] = useState(value);
    const [active, setActive] = useState(false);
    const [valChanged, setValChanged] = useState(false);

    const onClick = () => {
        if (valChanged === false) {
            setVal(value);
        }
        setActive(true);
    }

    const onInputChange = (val) => {
        setValChanged(true);
        setVal(val);
    }

    const onInactive = () => {
        setActive(false);
    }

    const onMouseLeave = () => {
        onInactive();
    }

    const onBlur = () => {
        onInactive();
    }

    const onSave = () => {
        if (onChange) {
            onChange(val);
        }
        setValChanged(false);
    }

    const onDeleteWrap = () => {
        if (onDelete) {
            onDelete();
            setVal(0);
        }
    }

    let content;
    if (active) {
        content =  <InputNumber addonAfter={addonAfter} min={min} max={max} precision={precision} onChange={onInputChange} value={value}
            onMouseLeave={onMouseLeave} onBlur={onBlur} placeholder={placeholder} />
    } else {
        content = <div style={{cursor: "pointer", color: "#108ee9", marginTop: '5px'}} onClick={onClick}>{`${val} ${addonAfter}`}</div>
    }

    const {name: productName, amount} = product;
    let button;
    if (valChanged === true) {
        button = <Button onClick={onSave}>Save</Button>
    } else if (amount > 0) {
        button = <div style={{marginTop: '5px'}}><TrashWidget onDelete={onDeleteWrap} /></div>
    }

    const rowStyle = {marginTop: '5px', marginBottom: '5px'}
    const offsetColStyle = {marginTop: '5px'}
    return <Row style={rowStyle}>
        <Col span={6} style={offsetColStyle}>
            {productName}
        </Col>
        <Col span={2}>
            {content}
        </Col>
        {(button) &&
            <Col>
                {button}
            </Col>
        }
    </Row>
}